module.exports = __webpack_public_path__ + "img/dog_digging.80df3470.svg";